import React  from "react";
import { connect } from "react-redux";
import MyDocuments from "./components/MyDocuments";

const EmployeeDocuments = () => {
  return (
    <MyDocuments />
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDocuments);